import React from "react";
import NumberFormat from "react-number-format";
import CardEmpty from "Utils/Cards/CardEmpty";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { PadresPTTable } from "./PadresPTTable";
import { DatosTurno } from "./DatosTurno";
import { PacasSecadora } from "./PacasSecadora";
import { SobranteTurno } from "./SobranteTurno";
import { useCierreTurnoForm } from "../hooks/useCierreTurnoForm";

export const DetalleProduccion = ({ regresar, irATurno }) => {
    const cierreTurnoForm = useCierreTurnoForm({ irATurno });

    const {
        turnoActualId,
        cargando,
        hayPacasEnSecadora,
        haySobranteTurno,
        totalProduccionAproximada,
        CerrarTurno,
    } = cierreTurnoForm;

    return (
        <div className="view__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <DatosTurno />
                    <PacasSecadora cierreTurnoForm={cierreTurnoForm} />
                    <SobranteTurno cierreTurnoForm={cierreTurnoForm} />
                    <PadresPTTable
                        cierreTurnoForm={cierreTurnoForm}
                        enlaceTancadasTurno={
                            turnoActualId
                                ? `/produccion-v2/tancadas-turno/${turnoActualId}`
                                : null
                        }
                    />

                    <div className="formulario-fields-column gap-1rem mt-3">
                        <div
                            className="formulario-field horizontal ml-auto"
                            style={{ minWidth: "250px" }}
                        >
                            <label
                                className="text-nowrap"
                                htmlFor="total_produccion"
                            >
                                {hayPacasEnSecadora || haySobranteTurno
                                    ? "Total de producción aprox. (Kg)"
                                    : "Total de producción (Kg)"}
                            </label>
                            <NumberFormat
                                className="form-control"
                                value={totalProduccionAproximada}
                                suffix=" Kg"
                                thousandSeparator=","
                                disabled
                                placeholder="0 kg"
                            />
                        </div>
                    </div>

                    <div className="d-flex flex-wrap justify-content-end my-4 gap-1rem">
                        <button
                            className="btn btn-outline-dark"
                            onClick={regresar}
                        >
                            Regresar
                        </button>

                        <button
                            className="btn btn-primary"
                            onClick={CerrarTurno}
                        >
                            Cerrar turno
                        </button>
                    </div>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
